<template>
  <div>
  </div>
</template>

<script>
import { COMPANY_PAGE_TYPE } from '@/constant/company'

export default {
  components: {
  },
  metaInfo () {
  },
  data () {
    return {
    }
  },
  computed: {
    companyId () {
      return this.$route.params.companyId
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData () {
      this.$router.replace(`/recruiting/company/${this.companyId}/${COMPANY_PAGE_TYPE.BRANDING}`)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
</style>
